import type {
  ComponentVariant,
  ComponentSize,
} from '../../../types/component.type';
import type { TypographyProps } from '@material-tailwind/react';

export type TextSize = 'tiny' | TypographyProps['variant'];

export type TextColor = 'inherit' | ComponentVariant;

export type TextWeight = 'light' | 'regular' | 'medium' | 'semibold' | 'bold';

export const getTextSize = (componentSize: ComponentSize): TextSize => {
  const sizeMap: Record<ComponentSize, TextSize> = {
    '2xs': 'tiny',
    xs: 'tiny',
    sm: 'tiny',
    md: 'small',
    lg: 'paragraph',
  };

  return sizeMap[componentSize] ?? 'small';
};

export const getControlTextSize = (componentSize: ComponentSize): TextSize => {
  const sizeMap: Record<ComponentSize, TextSize> = {
    '2xs': 'paragraph',
    xs: 'paragraph',
    sm: 'paragraph',
    md: 'paragraph',
    lg: 'paragraph',
  };

  return sizeMap[componentSize] ?? 'paragraph';
};

export const getColorClass = (color: TextColor): string => {
  if (color === 'inherit') return 'text-inherit';

  const colorMap: Record<ComponentVariant, string> = {
    primary: 'text-primary-700',
    secondary: 'text-secondary-700',
    success: 'text-success-700',
    danger: 'text-danger-700',
    warning: 'text-warning-700',
    info: 'text-info-700',
    neutral: 'text-neutral-600',
    whatsapp: 'text-whatsapp-700',
    call: 'text-call-700',
    email: 'text-email-700',
  };

  return colorMap[color];
};

export const getWeightClass = (weight: TextWeight): string => {
  const weightMap: Record<TextWeight, string> = {
    light: 'font-light',
    regular: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
  };

  return weightMap[weight];
};
